<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="order_no" placeholder="请扫工单号" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <el-card shadow="never" class="info-card">
      <el-row>
        <el-col :span="2" class="item-text">当前工站：</el-col>
        <el-col :span="6" class="item-value" :class="itemInfo.current_station_name === '流程已完成' ?'item-values':''">
          {{itemInfo.current_station_name }}</el-col>
        <el-col :span="2" class="item-text">工单号：</el-col>
        <el-col :span="6" class="item-value">{{ itemInfo.order_no }}</el-col>
        <el-col :span="2" class="item-text">客服人员：</el-col>
        <el-col :span="6" class="item-value">{{ itemInfo.service_user_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">品牌：</el-col>
        <el-col :span="6" class="item-value">{{ itemInfo.brand_name }}</el-col>
        <el-col :span="2" class="item-text">品类：</el-col>
        <el-col :span="6" class="item-value">{{ itemInfo.catalog_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">进流水线时间：</el-col>
        <el-col :span="6" class="item-value">{{ itemInfo.in_line_time }}</el-col>
        <el-col :span="2" class="item-text">出流水线时间：</el-col>
        <el-col :span="6" class="item-value">{{ itemInfo.out_line_time }}</el-col>
        <el-col :span="2" class="item-text">是否全部结束：</el-col>
        <el-col :span="6" class="item-value">{{ itemInfo.total_end }}</el-col>
      </el-row>

    </el-card>

    <KfTableTitle title="物品工站作业记录" style="margin-top: 20px"></KfTableTitle>
    <el-table :data="itemInfo.logList">
      <el-table-column label="工站" prop="station_name"></el-table-column>
      <el-table-column label="进站时间" prop="in_time"></el-table-column>
      <el-table-column label="出站时间" prop="out_time"></el-table-column>
      <el-table-column label="作业结果" prop="result_name"></el-table-column>
      <el-table-column label="作业人" prop="create_user_name"></el-table-column>
      <el-table-column label="内容">
        <template #default="scope">
          {{ getDetailData(scope.row) }}
        </template>
      </el-table-column>
    </el-table>


  </div>
</template>

<script>
export default {
  name: "OrderNoSearch",
  components: {},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      order_no: '',
      loading: false,
      itemInfo: {}
    }
  },
  computed: {},
  provide() {
    return {
      $fn: {
        reset: () => {
          this.order_no = ''
          this.reset();
        }
      }
    }
  },
  methods: {
    async search() {
      this.reset()
      //this.$refs.frameForm.formInfo = {} //清空作业表单内容

      if (!this.order_no) {
        return this.$refs.searchMessage.showError('工单号不能为空')
      }

      this.loading = true
      this.$http('oowItemService.getItemInfo', {
        order_no: this.order_no
      }, false).then(data => {
        this.loading = false
        this.itemInfo = data || {}
        if (this.itemInfo.current_station_name === undefined){
          this.itemInfo.current_station_name = '流程已完成';
        }
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })
    },
    reset() {
      this.itemInfo = {}
      this.$refs.searchMessage.clear()

    },
    getDetailData(row) {
      if (!row.form_data) {
        return
      }

      let text = ''
      try {
        let formData = JSON.parse(row.form_data);
        if (formData.order_no) {
          if (formData.remark){
            text = formData.remark
          }else {
            text = formData.quote_state
          }
        }

      } catch (e) {
        console.error(e)
      }
      return text;

    }
  }
}
</script>

<style scoped>
.el-row {
  line-height: 32px;
}

.info-card {
  margin-top: 10px;
}

.remind-card {
  margin-top: 10px;
  width: 1000px;
}

.info-card .el-row {
  display: flex;
}

.input {
  height: 32px;
  width: 350px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: left;
}

.item-value {
  color: goldenrod;
}

.item-values {
  color: #06e706;
}

.login-user {
  position: absolute;
  right: 10px;
}

.item-text {
  text-align: right;
}

.item-value.red-tip {
  color: red;
}

</style>